import { EAuthenticateStatus, EMergeStatus } from '../../types/social';
export function hasErrorSelector(state) {
  var authenticate = state.authentication.authenticate;
  var merge = state.social.merge;
  return authenticate.status === EAuthenticateStatus.Failed || merge.status === EMergeStatus.Failed;
}
export function isSubmittingSelector(state) {
  var authenticate = state.authentication.authenticate;
  var merge = state.social.merge;
  return authenticate.status === EAuthenticateStatus.Loading || merge.status === EMergeStatus.Loading;
}
export function hasMerdgeErrorSelector(state) {
  var merge = state.social.merge;
  var authenticate = state.authentication.authenticate;
  return merge.status === EMergeStatus.Failed || authenticate.status === EAuthenticateStatus.Failed && merge.status === EMergeStatus.Succeed;
}
export function mergeErrorSelector(state) {
  if (!hasErrorSelector(state)) {
    return undefined;
  }

  var merge = state.social.merge;
  var authenticate = state.authentication.authenticate;
  return merge.status === EMergeStatus.Failed ? merge.error : authenticate.error;
}
export function socialTypeSelector(state) {
  return state.social.merge.socialType;
}
export function socialLoginIdSelector(state) {
  return state.social.merge.socialLoginId;
}
export function emailSelector(state) {
  return state.social.merge.email;
}